import { render, staticRenderFns } from "./VoiceConfig.vue?vue&type=template&id=39f3cae6&scoped=true"
import script from "./VoiceConfig.vue?vue&type=script&lang=js"
export * from "./VoiceConfig.vue?vue&type=script&lang=js"
import style0 from "./VoiceConfig.vue?vue&type=style&index=0&id=39f3cae6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3cae6",
  null
  
)

export default component.exports